import React from 'react';
import PropTypes from 'prop-types';
import useMegaMenu from './hooks/useMegaMenu';
import MegaMenuDesktop from './components/MegaMenuDesktop';
import MegaMenuMobile from './components/MegaMenuMobile';

const MegaMenu = ({ headerSettingsId }) => {
  const { results } = useMegaMenu(headerSettingsId);

  return (
    <>
      <MegaMenuDesktop megaMenu={results} />
      <MegaMenuMobile megaMenu={results} />
    </>
  );
};

MegaMenu.propTypes = {
  headerSettingsId: PropTypes.string
};

export default MegaMenu;
